import "less/app.less";

import {DHXApp} from "dhx-optimus";

import {DHXView} from "dhx-optimus";




import {TopMenuView} from "views/topmenu.js";

//import {MyOfficeApp} from "views/office/myoffice.js";


class MyApp extends DHXApp{
	constructor(config){
		super(config);
		var self = this;

		console.log("constructor MyApp");
		
		console.log("location: " + JSON.stringify(location));
		
		var ipaddress = location.host;
		console.log("ipaddress: " + ipaddress);
		self.webAPI = new AjaxComponent.webAPI("http://" + ipaddress + URLComponent.webAPI());
		self.addService("webAPI", self.webAPI);

		
		//this.attachEvent("MenuClick", (id) => dhtmlx.alert(id + " button was clicked"));
		self.attachEvent("MenuClick", (id) => {

			//self.onMenuClick(id);
		});

		/*
		self.sendCommand("http://raspberrypi:80/api/", "", function(data) {
			console.log("data: " + JSON.stringify(data));
		});
		*/
	}
	
	sendCommand( baseURL, command, callback ) {
		
		$.ajax({
			type: "GET",
			url: baseURL + "Command/" + command,
			data: "",//JSON.stringify(element),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (data, status) {

				//console.log("printers: " + data);
				
				if (callback != null) {			
					callback(data);
				}
				
			},
			error: function (request, status, error) {
				console.log("error in sendCommand: " + request.responseText);
			}
		});
	};
	
	onMenuClick(id) {
		var self = this;
		
		//dhtmlx.alert(id + " button was clicked")
		//console.log(id + " button was clicked");
		

		if(id == "t1") {

		}
		if(id == "t2") {

		}
		if(id == "t3") {

		}
		if(id == "t4") {

		}		
		
	}
	
	render(){
		var self = this;
		
		//self.show(TopView);
		self.view = new TopMenuView();

		self.show(self.view);
		//self.show(TopRibbonView);
		
		self.attachEvent("onResize", () => {

			//console.log("event: onResize");
			
			self.view.ui.setSizes();
		});
		
		//self.show(XTopView);
		

	dhtmlXGridObject.prototype._process_myjson = function(data, mode) {
		//console.log("self._process_myjson");
						
		this._parsing = true;
		try {
			var data = data.responseText || data;
			if (typeof data == "string") {
				eval("dhtmlx.temp=" + data + ";");
				data = dhtmlx.temp
			}
		} catch (e) {
			dhx4.callEvent("onLoadXMLError", ["Incorrect JSON", (data.xmlDoc || data), this]);
			data = {
				rows: []
			}
		}
		if (this._refresh_mode) {
			//console.log("_refresh_mode");
			return this._refreshFromJSON(data)
		}
		if (data.head) {
			this._parseHeadJson(data)
		}
		this._parseOptionsJson(data);
		var cr = parseInt(data.pos || 0);
		var total = parseInt(data.total_count || 0);
		var reset = false;
		if (total) {
			if (!this.rowsBuffer[total - 1]) {
				if (this.rowsBuffer.length) {
					reset = true
				}
				this.rowsBuffer[total - 1] = null
			}
			if (total < this.rowsBuffer.length) {
				this.rowsBuffer.splice(total, this.rowsBuffer.length - total);
				reset = true
			}
		}
		//console.log("pos: " + cr);
		//console.log("total: " + total);
		//console.log("reset: " + reset);
		
		var userdata = mode === "js" ? data.userdata : data;
		for (var key in userdata) {
			if (mode === "js" || key != "rows") {
				this.setUserData("", key, userdata[key])
			}
		}
		if (mode == "js" && data.collections) {
			for (var colkey in data.collections) {
				var index = this.getColIndexById(colkey);
				var colrecs = data.collections[colkey];
				if (index !== window.undefined) {
					if (this.cellType[index] == "clist") {
						colplaindata = [];
						for (var j = 0; j < colrecs.length; j++) {
							colplaindata.push(colrecs[j].label)
						}
						this.registerCList(index, colplaindata)
					} else {
						var combo = this.getCombo(index);
						for (var j = 0; j < colrecs.length; j++) {
							combo.put(colrecs[j].value, colrecs[j].label)
						}
					}
				}
			}
		}
		if (this.isTreeGrid()) {
			return this._process_tree_json(data, null, null, mode)
		}
		if (mode == "js") {
			//console.log("if (mode == 'js')");
			if (data.data) {
				data = data.data
			}
			for (var i = 0; i < data.length; i++) {
				if (this.rowsBuffer[i + cr]) {
					continue
				}
				var row = data[i];
				var id = row.id || (i + cr);
				this.rowsBuffer[i + cr] = {
					idd: id,
					data: row,
					_parser: this._process_js_row,
					_locator: this._get_js_data
				};
				this.rowsAr[id] = data[i]
			}
		} else {
			for (var i = 0; i < data.rows.length; i++) {
				if (this.rowsBuffer[i + cr]) {
					continue
				}
				var id = data.rows[i].id;
				this.rowsBuffer[i + cr] = {
					idd: id,
					data: data.rows[i],
					_parser: this._process_json_row,
					_locator: this._get_json_data
				};
				this.rowsAr[id] = data.rows[i]
			}

		}
		this.callEvent("onDataReady", []);
		if (reset && this._srnd) {
			var h = this.objBox.scrollTop;
			this._reset_view();
			this.objBox.scrollTop = h
		} else {
			this.render_dataset()
		}
		this._parsing = false
	}
				
	}


}

window.MyApp = MyApp;


// WEBPACK FOOTER //
// ./sources/app.js